import { render, staticRenderFns } from "./free-treat-upgrade.vue?vue&type=template&id=6293136a&"
import script from "./free-treat-upgrade.vue?vue&type=script&lang=js&"
export * from "./free-treat-upgrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports